import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { createStyles, Grid, makeStyles } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-enterprise";

type Props = EditableCallbackParams;

const useStyles = makeStyles((theme) =>
	createStyles({
		input: {
			"&:focus::placeholder": {
				color: "transparent !important",
			},
		},
	}),
);
export const LOTONumberColumn = ({ data }: Props) => {
	const classes = useStyles();
	const {
		state: { LOTONumberToLink },
		actions: { setLOTONumberToLink },
	} = useTemplatesContext();

	const handleChangeLOTONumberChange = (e: any) => {
		setLOTONumberToLink(e.target.value.toUpperCase());
	};

	if (data.id === -1) {
		return (
			<Grid
				container
				style={{
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<input
					style={{
						outline: "none",
						border: "none",
						lineBreak: "auto",
						textAlign: "center",
						width: 148,
						maxWidth: 148,
						marginRight: "10px",
					}}
					value={LOTONumberToLink}
					onChange={handleChangeLOTONumberChange}
					placeholder={"Put a Number"}
					className={classes.input}
					autoFocus
					autoComplete="false"
				/>
			</Grid>
		);
	} else return data?.LOTONumber;
};
